/** Keep codes/labels aligned with OhanaGateway `categorization/plaid-my-category.txt` (AI My category). */
export const PERSONAL_CATEGORIES = [
    /* Business revenue — payer / insurance deposits, etc. (codes ≤10 chars for DB) */
    { code: 'binsrev', label: 'Insurance deposit / payer payment (revenue)', group: 'Business revenue' },
    { code: 'b_svc_rev', label: 'Client / service payment (revenue)', group: 'Business revenue' },
    { code: 'b_rev_oth', label: 'Other business revenue', group: 'Business revenue' },
    /* Common business expenses */
    { code: 'b_payroll', label: 'Payroll (W-2 employees)', group: 'Business expenses' },
    { code: 'b_401kmed', label: '401K & employee medical benefits', group: 'Business expenses' },
    { code: 'b_benefit', label: 'Employee benefits (dental, vision, other)', group: 'Business expenses' },
    { code: 'b_contr', label: 'Contractors / 1099', group: 'Business expenses' },
    { code: 'b_hiring', label: 'Hiring & recruiting (job ads, recruiters, signing costs)', group: 'Business expenses' },
    { code: 'b_softwr', label: 'Software & SaaS (business)', group: 'Business expenses' },
    { code: 'b_offsup', label: 'Office supplies', group: 'Business expenses' },
    { code: 'b_equip', label: 'Equipment & repairs', group: 'Business expenses' },
    { code: 'b_offrent', label: 'Office / clinic rent', group: 'Business expenses' },
    { code: 'b_utils', label: 'Utilities (business location)', group: 'Business expenses' },
    { code: 'b_bizins', label: 'Business insurance (liability, etc.)', group: 'Business expenses' },
    { code: 'b_profl', label: 'Legal, accounting, professional fees', group: 'Business expenses' },
    { code: 'b_market', label: 'Marketing & advertising', group: 'Business expenses' },
    { code: 'b_ccproc', label: 'Card / payment processing fees', group: 'Business expenses' },
    { code: 'b_taxfee', label: 'Business taxes & licenses', group: 'Business expenses' },
    { code: 'b_taxcpa', label: 'CPA / tax preparer (business return filing)', group: 'Business expenses' },
    { code: 'b_train', label: 'Training, CEUs, conferences', group: 'Business expenses' },
    { code: 'b_travel', label: 'Business travel & mileage', group: 'Business expenses' },
    { code: 'b_teleph', label: 'Business phone & internet', group: 'Business expenses' },
    { code: 'b_ship', label: 'Shipping & delivery', group: 'Business expenses' },
    { code: 'b_bankfe', label: 'Bank & wire fees', group: 'Business expenses' },
    { code: 'b_misc', label: 'Business — other / misc', group: 'Business expenses' },

    { code: 'h1', label: 'Groceries', group: 'Essentials' },
    { code: 'h2', label: 'Utilities (Electric/Gas/Water)', group: 'Essentials' },
    { code: 'h3', label: 'Internet / Cable / Phone', group: 'Essentials' },
    { code: 'h4', label: 'Rent / Mortgage', group: 'Essentials' },
    { code: 'h5', label: 'Home Insurance', group: 'Essentials' },
    { code: 'h6', label: 'Auto Insurance', group: 'Essentials' },
    { code: 'h7', label: 'Health Insurance', group: 'Essentials' },
    { code: 'h54', label: 'Property Tax', group: 'Essentials' },
    { code: 'h8', label: 'Gas / Fuel', group: 'Transportation' },
    { code: 'h9', label: 'Car Payment', group: 'Transportation' },
    { code: 'h10', label: 'Public Transit / Rideshare', group: 'Transportation' },
    { code: 'h11', label: 'Parking', group: 'Transportation' },
    { code: 'h12', label: 'Car Maintenance / Repair', group: 'Transportation' },
    { code: 'h13', label: 'Dining Out / Restaurants', group: 'Food & Drink' },
    { code: 'h14', label: 'Coffee Shops', group: 'Food & Drink' },
    { code: 'h15', label: 'Fast Food / Takeout', group: 'Food & Drink' },
    { code: 'h16', label: 'Alcohol / Bars', group: 'Food & Drink' },
    { code: 'h17', label: 'Medical / Doctor', group: 'Health' },
    { code: 'h18', label: 'Pharmacy / Prescriptions', group: 'Health' },
    { code: 'h19', label: 'Dental', group: 'Health' },
    { code: 'h20', label: 'Vision / Eye Care', group: 'Health' },
    { code: 'h21', label: 'Gym / Fitness', group: 'Health' },
    { code: 'h53', label: 'Squash Lessons', group: 'Health' },
    { code: 'h22', label: 'Childcare / Daycare', group: 'Family' },
    { code: 'h23', label: 'Kids Activities / Lessons', group: 'Family' },
    { code: 'h24', label: 'School Supplies / Tuition', group: 'Family' },
    { code: 'h25', label: 'Pet Care / Vet', group: 'Family' },
    { code: 'h26', label: 'Clothing / Apparel', group: 'Shopping' },
    { code: 'h27', label: 'Electronics / Tech', group: 'Shopping' },
    { code: 'h28', label: 'Home Goods / Furniture', group: 'Shopping' },
    { code: 'h29', label: 'Amazon / Online Shopping', group: 'Shopping' },
    { code: 'h30', label: 'Personal Care / Beauty', group: 'Shopping' },
    { code: 'h56', label: 'Target', group: 'Shopping' },
    { code: 'h31', label: 'Streaming / Subscriptions', group: 'Entertainment' },
    { code: 'h32', label: 'Movies / Events / Concerts', group: 'Entertainment' },
    { code: 'h33', label: 'Hobbies / Recreation', group: 'Entertainment' },
    { code: 'h34', label: 'Books / Education', group: 'Entertainment' },
    { code: 'h35', label: 'Games / Apps', group: 'Entertainment' },
    { code: 'h36', label: 'Vacation / Travel', group: 'Travel' },
    { code: 'h37', label: 'Hotels / Lodging', group: 'Travel' },
    { code: 'h38', label: 'Flights / Airfare', group: 'Travel' },
    { code: 'h55', label: 'Squash Travel', group: 'Travel' },
    { code: 'h39', label: 'Gifts / Presents', group: 'Other' },
    { code: 'h40', label: 'Charitable Donations', group: 'Other' },
    { code: 'h41', label: 'ATM / Cash Withdrawal', group: 'Other' },
    { code: 'h42', label: 'Bank Fees / Interest', group: 'Other' },
    { code: 'h_taxcpa', label: 'Tax preparation (CPA / tax pro)', group: 'Other' },
    { code: 'h43', label: 'Transfers', group: 'Other' },
    { code: 'h44', label: 'Loan Payment', group: 'Other' },
    { code: 'h45', label: 'Savings / Investment', group: 'Other' },
    { code: 'h46', label: 'Misc / Uncategorized', group: 'Other' },
    { code: 'h47', label: 'Salary / Paycheck', group: 'Income' },
    { code: 'h48', label: 'Bonus / Commission', group: 'Income' },
    { code: 'h49', label: 'Refund / Reimbursement', group: 'Income' },
    { code: 'h50', label: 'Side Income / Freelance', group: 'Income' },
    { code: 'h51', label: 'Account Transfer (Non-Expense)', group: 'Non-Expense' },
    { code: 'h52', label: 'Credit Card Payment', group: 'Non-Expense' },
];

export const PERSONAL_CAT_MAP = Object.fromEntries(PERSONAL_CATEGORIES.map(c => [c.code, c]));
export const PERSONAL_GROUPS = [...new Set(PERSONAL_CATEGORIES.map(c => c.group))];
export const PERSONAL_CAT_LABELS = Object.fromEntries(PERSONAL_CATEGORIES.map(c => [c.code, c.label]));

/** My category codes in group "Non-Expense" (e.g. transfers, card payments) — not treated as spend/credit buckets in Plaid views. */
export const PERSONAL_NON_EXPENSE_CODES = new Set(
    PERSONAL_CATEGORIES.filter((c) => c.group === 'Non-Expense').map((c) => c.code),
);
